import { useQuery } from '@tanstack/react-query'

import { fetchReservationBookerContact } from '@/lib/venue/reservationApi'
import type { ReservationBookerContactView } from '@/lib/venue/reservationTypes'

export function reservationBookerContactQueryKey(venueId: string, reservationId: number) {
  return ['venue', venueId, 'reservation', reservationId, 'booker-contact'] as const
}

/**
 * `enabled: false` 로 선언 — 화면 진입 시 자동으로 부르지 않는다. "예약자 연락" 버튼 클릭 시에만
 * `refetch()` 한다(#666 §5 — 호출 자체가 열람 기록으로 남기 때문. 설계 §2-3(d)).
 */
export function useVenueReservationBookerContact(venueId: string, reservationId: number) {
  return useQuery<ReservationBookerContactView>({
    queryKey: reservationBookerContactQueryKey(venueId, reservationId),
    queryFn: () => fetchReservationBookerContact(venueId, reservationId),
    enabled: false,
  })
}
